export enum TypeBeneficiaireDecaissement {
  FOURNISSEUR = 'fournisseur',
  BENEFICIAIRE = 'beneficiaire',
}

export enum MotifDecaissement {
  ACHAT = 'achat',
  MATIERE_PREMIERE = 'matiere_premiere',
  ACHAT_SERVICE = 'achat_service',
  AVANCE_SALAIRE = 'avance_salaire',
}

export enum TypePaiementDecaissement {
  TOTALITE = 'totalite',
  PARTIEL = 'partiel',
}

export enum StatusDecaissement {
  BROUILLON = 'brouillon',
  VALIDEE = 'validee',
  ANNULEE = 'annulee',
}

export interface Decaissement {
  id: number;
  reference: string;
  date: string;
  projet_id: number | null;
  projet_nom?: string | null;
  beneficiaire_type: string;
  fournisseur_id: number | null;
  fournisseur_name?: string | null;
  beneficiaire_id: number | null;
  beneficiaire_name?: string | null;
  motif: string;
  libelle?: string | null;
  paiement_type: string;
  montant_total: number;
  montant_paye: number;
  reste: number;
  mode_paiement_id: number | null;
  mode_paiement_nom?: string | null;
  reference_paiement?: string | null;
  piece_justificatif?: string | null;
  status: string;
  date_echeance?: string | null;
  user_id: number;
  user_name?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;
}

export interface DecaissementCreate {
  date: string;
  projet_id?: number | null;
  beneficiaire_type: string;
  fournisseur_id?: number | null;
  beneficiaire_id?: number | null;
  motif: string;
  libelle?: string | null;
  paiement_type: string;
  montant_total: number;
  montant_paye: number;
  reste?: number;
  mode_paiement_id?: number | null;
  reference_paiement?: string | null;
  piece_justificatif?: string | null;
  status?: string;
  date_echeance?: string | null;
}

export interface DecaissementUpdate {
  date?: string;
  projet_id?: number | null;
  beneficiaire_type?: string;
  fournisseur_id?: number | null;
  beneficiaire_id?: number | null;
  motif?: string;
  libelle?: string | null;
  paiement_type?: string;
  montant_total?: number;
  montant_paye?: number;
  reste?: number;
  mode_paiement_id?: number | null;
  reference_paiement?: string | null;
  piece_justificatif?: string | null;
  status?: string;
  date_echeance?: string | null;
}

export interface DecaissementListResponse {
  total: number;
  items: Decaissement[];
}

// Helper for motif labels
export const MOTIF_LABELS: Record<string, string> = {
  achat: 'Achat',
  matiere_premiere: 'Matière Première',
  achat_service: 'Achat de Service',
  avance_salaire: 'Avance sur Salaire',
};

// Helper for status labels
export const STATUS_LABELS: Record<string, string> = {
  brouillon: 'Brouillon',
  validee: 'Validée',
  annulee: 'Annulée',
};

// Helper for beneficiaire type labels
export const BENEFICIAIRE_TYPE_LABELS: Record<string, string> = {
  fournisseur: 'Fournisseur',
  beneficiaire: 'Autre Bénéficiaire',
};

// Helper for paiement type labels
export const PAIEMENT_TYPE_LABELS: Record<string, string> = {
  totalite: 'Totalité',
  partiel: 'Partiel',
};
